module.exports = __webpack_public_path__ + "img/plantation_tech_Normal_ua.5b8aed72.webp";